import userIcon from "../../medias/userIcon.svg";
import { Container, Typography } from "@mui/material";
import { CriticalError } from "../CriticalError";
import {
    Group,
    InputButton,
    InputField,
    showSimpleSnackbarDispatcher,
    showSnackbar,
} from "../../components/";
import { Page } from "../Page";
import { apiClient } from "../../api/";
import { styles } from "../../theme/";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

/**
 * NewEmail page
 */
export const NewEmail = () => {
    // Hooks
    const navigate = useNavigate();

    // useStates
    const [criticalError, setCriticalError] = useState<boolean>(false);
    const [email, setEmail] = useState<string>("");
    const [error, setError] = useState<boolean>(false);

    // useMemos
    const token = useMemo(() => localStorage.getItem("token"), []);

    // Handlers
    const handleSendChangeEmail = async (token: string) => {
        try {
            const [response, statusOk] = await apiClient.sendChangeEmail(token, email);

            if (statusOk) {
                showSnackbar({ message: `Change email sent.`, variant: "success" });
                navigate("/signIn");
            } else {
                setError(true);
                showSimpleSnackbarDispatcher(response as { [key: string]: string[]; });
            }
        } catch (error) {
            setCriticalError(true);
            showSnackbar({ message: String(error), variant: "error" });
        }
    };

    // Early return
    if (criticalError) return <CriticalError />;

    return (
        <Page needsAuthentication menu>
            <Container style={styles.inPlaceModal} >
                <Typography style={{ fontFamily: "ArchivoBlack", fontSize: 36 }} >Change Email</Typography>
                <InputField type="email" value={email} leftIcon={userIcon} placeholder={"Email"} error={error} setValue={setEmail} />
                <Group direction="row">
                    <InputButton type="main" onClick={() => navigate(-1)} tooltip="Go back">Back</InputButton>
                    {token && email
                        ? <InputButton type="secondary" onClick={() => handleSendChangeEmail(token)} tooltip="Sent change email">Send email</InputButton>
                        : <InputButton type="primary" disabled>Send email</InputButton>
                    }
                </Group>
            </Container>
        </Page>
    );
};